import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { useLocation, useParams } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import "../styles/components/_blog.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
const Blogs = () => {
  const [blogs, setBlogs] = useState([null]); // State to store blog data
  const { slug } = useParams();
  const location = useLocation(); // Call the hook to get the location object
  const link = `${window.location.origin}${location.pathname}`; // Construct the full URL

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const blogRef = collection(db, "posts");
        const q = query(blogRef, where("slug", "==", slug));
        const blog = await getDocs(q);
        const blogData = blog.docs[0].data();
        setBlogs(blogData);
      } catch (error) {
        console.error("Error connecting to Firestore:", error);
      }
    };

    fetchBlog();
  }, [slug]);

  return (
    <div className="blog-wrapper">
      <div key={blogs.id} className="blog">
        <div className="blog-header">
          <h2>{blogs.title}</h2>
          <p>{blogs.description}</p>
        </div>
        <img src={blogs.mainImage} alt={blogs.title} className="blog-image" />
        {/* Render HTML content */}
        <div className="main">
          <div
            className="mainContent"
            dangerouslySetInnerHTML={{ __html: blogs.content }}
          ></div>
          <div className="blog-sidebar">
            <p>Published on:</p>
            <span>
              {blogs.createdAt
                ? new Date(blogs.createdAt.seconds * 1000).toLocaleDateString(
                    "en-GB",
                    {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    }
                  )
                : "Date not available"}
            </span>
            <p>Reading Time:</p>
            <span>{blogs.readTime} minutes</span>
            <p>Share:</p>
            <div className="social-icons">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${link}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${link}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                  link
                )}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
            </div>
          </div>
        </div>
        <h3>Tags:</h3>
        <ul>
          {blogs.tags &&
            blogs.tags.map((tag, index) => <li key={index}>{tag}</li>)}
        </ul>
      </div>
    </div>
  );
};

export default Blogs;
